import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterMaestroDocumentoModel } from 'src/app/models/interfaces/maestro-documento/IFilterMaestroDocumentoModel';
import { IMaestroDocumentoCreateModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoCreateModel';
import { IMaestroDocumentoModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoModel';
import { IMaestroDocumentoUpdateModel } from 'src/app/models/interfaces/maestro-documento/IMaestroDocumentoUpdateModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MaestroDocumentosService {
  private configUrl = [
    environment.apiGatewayUrl,
    'maestro-documentos',
  ].join('/');
  
  constructor(
    private http: HttpClient
  ) { }

  getListPaged(
    model: IFilterMaestroDocumentoModel
  ): Observable<SearchResultModel<IMaestroDocumentoModel[]>> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    queryParams.push(`documento=${model.documento}`);

    return this.http.get<SearchResultModel<IMaestroDocumentoModel[]>>(
      this.configUrl + '?'+ queryParams.join('&')
    );
  }

  getList(
    model: IFilterMaestroDocumentoModel
  ): Observable<IMaestroDocumentoModel[]> {
    let queryParams: string[] = new Array<string>();
    
    queryParams.push(`idEstado=${model.idEstado}`);

    return this.http.get<IMaestroDocumentoModel[]>(
      `${this.configUrl}/all/?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<IMaestroDocumentoModel> {
    return this.http.get<IMaestroDocumentoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IMaestroDocumentoCreateModel) {
    return this.http.post<IMaestroDocumentoCreateModel>(`${this.configUrl}`, model);
  }

  update(model: IMaestroDocumentoUpdateModel) {
    return this.http.put<IMaestroDocumentoUpdateModel>(
      `${this.configUrl}/${model.idMaestroDocumento}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete(`${this.configUrl}/${id}`);
  }
}
